import { render, staticRenderFns } from "./DistributionPanel.vue?vue&type=template&id=019e558a&scoped=true&"
import script from "./DistributionPanel.vue?vue&type=script&lang=js&"
export * from "./DistributionPanel.vue?vue&type=script&lang=js&"
import style0 from "./DistributionPanel.vue?vue&type=style&index=0&id=019e558a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e558a",
  null
  
)

export default component.exports